(() => {
  const pickupSelector = '.frengee-pickup-block';

  function storeLabel(store) {
    const address = store.querySelector('.frengee-store__address');
    if (address) {
      const cityLine = address.innerText
        .split('\n')
        .map((line) => line.trim())
        .find((line) => line.includes(','));

      if (cityLine) return cityLine.split(',')[0];
    }

    return store.querySelector('.frengee-store__name')?.textContent.trim() || 'store';
  }

  function enhancePickup(root) {
    const title = root.querySelector('[data-frengee-summary-title]');
    const subtext = root.querySelector('[data-frengee-summary-subtext]');
    const icon = root.querySelector('[data-frengee-summary-status]');
    const link = root.querySelector('.frengee-pickup__link');
    const stores = Array.from(root.querySelectorAll('.frengee-store'));

    if (!title || !subtext || !stores.length) return;

    const pickupStores = stores.filter((store) => !store.classList.contains('frengee-store--pickup-disabled'));
    const inStore = pickupStores.filter((store) => store.querySelector('.frengee-badge--success'));
    const transfers = pickupStores.filter((store) => {
      const status = store.querySelector('.frengee-store__status-text')?.textContent || '';
      return store.querySelector('.frengee-badge--error') && /pickup available/i.test(status);
    });
    const warehouse = stores.find((store) =>
      store.classList.contains('frengee-store--pickup-disabled') &&
      store.querySelector('.frengee-badge--success')
    );

    if (inStore.length) {
      const first = inStore[0];
      const name = storeLabel(first);
      const readyText = first.querySelector('.frengee-store__status-text')?.textContent || '';

      title.textContent = inStore.length === 1
        ? `In stock now at ${name}`
        : `In stock now at ${inStore.length} stores`;
      subtext.textContent = inStore.length === 1
        ? readyText.replace(/^Pickup available,?\s*/i, '')
        : inStore.map(storeLabel).join(' \u00b7 ');

      if (icon) {
        icon.textContent = '\u2713';
        icon.classList.remove('frengee-pickup__status--transfer');
      }
    } else if (warehouse && transfers.length) {
      const names = transfers.map(storeLabel);

      title.textContent = 'In stock';
      subtext.textContent = `Transfer to ${names.map((n) => n.replace(/ City$/, '')).join(' or ')} Shops for pickup`;

      if (icon) {
        icon.textContent = '\u21bb';
        icon.classList.add('frengee-pickup__status--transfer');
      }

    }

    if (warehouse && transfers.length) {
      transfers.forEach((store) => {
        const badge = store.querySelector('.frengee-badge');
        const status = store.querySelector('.frengee-store__status-text');

        if (badge) {
          badge.textContent = 'In stock';
          badge.classList.remove('frengee-badge--error');
          badge.classList.add('frengee-badge--transfer');
        }

        if (status) status.textContent = 'Transfer to this location for pickup';
      });

    }

    if (warehouse) {
      const previousDivider = warehouse.previousElementSibling;
      if (previousDivider?.classList.contains('frengee-divider')) previousDivider.hidden = true;
      warehouse.hidden = true;
    }

    if (link) link.textContent = 'View pickup options';
  }

  function enhanceAll() {
    document.querySelectorAll(pickupSelector).forEach(enhancePickup);
  }

  function positionFamilyPicker() {
    const grid = document.querySelector('.gc-product-family__grid--scroll');
    const current = grid?.querySelector('[aria-current="page"]');

    if (grid && current) {
      grid.scrollTop = Math.max(0, current.offsetTop - grid.offsetTop - 8);
    }
  }

  function initializeFamilyScrollHint() {
    const grid = document.querySelector('.gc-product-family__grid--scroll');
    const button = document.querySelector('[data-gc-family-more]');
    const label = button?.querySelector('[data-gc-family-more-label]');

    if (!grid || !button || !label) return;

    function update() {
      const atBottom = grid.scrollTop + grid.clientHeight >= grid.scrollHeight - 4;
      button.dataset.direction = atBottom ? 'up' : 'down';
      label.textContent = atBottom ? 'Back to first build' : button.dataset.moreLabel;
    }

    button.addEventListener('click', () => {
      const goToTop = button.dataset.direction === 'up';
      grid.scrollTo({
        top: goToTop ? 0 : Math.min(grid.scrollHeight, grid.scrollTop + grid.clientHeight - 50),
        behavior: 'smooth'
      });
    });

    grid.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initializeFamilySizeFilter() {
    const buttons = Array.from(document.querySelectorAll('[data-family-size-filter]'));
    const cards = Array.from(document.querySelectorAll('.gc-product-family__card'));
    const grid = document.querySelector('.gc-product-family__grid');

    if (!buttons.length || !cards.length) return;

    function applySize(size) {
      buttons.forEach((button) => {
        const active = button.dataset.familySize === size;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      cards.forEach((card) => {
        const chips = Array.from(card.querySelectorAll('[data-family-size-chip]'));
        const selectedChip = size ? chips.find((chip) => chip.dataset.familySizeChip === size) : null;
        const available = selectedChip?.dataset.sizeAvailable === 'true';
        const status = card.querySelector('[data-family-build-status]');

        card.href = size && available && selectedChip.dataset.sizeVariantUrl
          ? selectedChip.dataset.sizeVariantUrl
          : card.dataset.familyDefaultUrl;

        chips.forEach((chip) => chip.classList.toggle('is-selected', Boolean(size) && chip === selectedChip));
        card.classList.toggle('is-size-available', Boolean(size) && available);
        card.classList.toggle('is-size-unavailable', Boolean(size) && !available);

        if (!status) return;

        if (size) {
          status.textContent = `${size} ${available ? 'available' : 'unavailable'}`;
          status.classList.toggle('gc-product-family__status--available', available);
          status.classList.toggle('gc-product-family__status--sold-out', !available);
        } else {
          const defaultAvailable = status.dataset.defaultAvailable === 'true';
          status.textContent = status.dataset.defaultStatus;
          status.classList.toggle('gc-product-family__status--available', defaultAvailable);
          status.classList.toggle('gc-product-family__status--sold-out', !defaultAvailable);
        }
      });

      if (grid?.classList.contains('gc-product-family__grid--scroll')) {
        grid.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => applySize(button.dataset.familySize || ''));
    });
  }

  /* ------------------------------------------------------------------
     GALLERY <-> VARIANT SYNC (GC PDP on Horizon's native media gallery)

     The GC buy box renders its own option pickers, so Horizon's normal
     variant flow (which re-renders <media-gallery> on productSelect)
     never runs. The buy box's own image swap targeted markup from the
     old custom gallery and did nothing against Horizon's.

     This watches the same picker interactions, reads the selected
     variant's photo from #variant-data (data-img), finds the rendered
     slide showing that same image file, and tells Horizon's slideshow
     to jump to it. File matching is used instead of IDs because the
     slides don't carry media ids, and image ids and media ids are
     different ID spaces anyway.
  ------------------------------------------------------------------ */
  function initializeGallerySync() {
    const dataEl = document.getElementById('variant-data');
    const gallery = document.querySelector('.product-gallery media-gallery');
    if (!dataEl || !gallery) return;

    const fileOf = (url) => {
      if (!url) return '';
      try {
        return decodeURIComponent(url.split('?')[0].split('/').pop() || '').toLowerCase();
      } catch (e) {
        return (url.split('?')[0].split('/').pop() || '').toLowerCase();
      }
    };

    function selections() {
      const opts = ['', '', ''];
      document.querySelectorAll('.variant-btn.active').forEach((b) => {
        const i = parseInt(b.dataset.optionIndex, 10);
        if (!isNaN(i)) opts[i] = b.dataset.value || '';
      });
      document.querySelectorAll('.gc-select').forEach((s) => {
        const i = parseInt(s.dataset.optionIndex, 10);
        if (!isNaN(i)) opts[i] = s.value || '';
      });
      return opts;
    }

    function selectedVariantEl() {
      const opts = selections();
      const spans = dataEl.querySelectorAll('span[data-id]');
      for (const s of spans) {
        if (opts[0] && s.dataset.o1 !== opts[0]) continue;
        if (opts[1] && s.dataset.o2 !== opts[1]) continue;
        if (opts[2] && s.dataset.o3 !== opts[2]) continue;
        return s;
      }
      return null;
    }

    function sync() {
      const v = selectedVariantEl();
      if (!v) return;
      const file = fileOf(v.dataset.img);
      if (!file) return;

      const slides = gallery.querySelectorAll('slideshow-component slideshow-slide');
      let index = -1;
      slides.forEach((slide, i) => {
        if (index >= 0) return;
        const img = slide.querySelector('img');
        const src = img ? (img.currentSrc || img.src || '') : '';
        if (src && fileOf(src) === file) index = i;
      });
      if (index < 0) return;

      if (gallery.slideshow && typeof gallery.slideshow.select === 'function') {
        try {
          gallery.slideshow.select(index, undefined, { animate: false });
        } catch (e) {
          /* no-op */
        }
      }

      // Grid presentation hides the slideshow on desktop; scroll the matching
      // grid image into view instead.
      if (gallery.dataset.presentation === 'grid' && window.matchMedia('(min-width: 750px)').matches) {
        const items = gallery.querySelectorAll('.media-gallery__grid > li');
        const target = items[index];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    // The buy box's own handlers run first (they were registered while the
    // document was parsing; this file is deferred). rAF waits out the class
    // updates before reading the new selection.
    document.addEventListener('click', (e) => {
      if (e.target.closest('.variant-btn')) requestAnimationFrame(sync);
    });
    document.addEventListener('change', (e) => {
      if (e.target.closest('.gc-select')) requestAnimationFrame(sync);
    });
  }

  function initialize() {
    enhanceAll();
    positionFamilyPicker();
    initializeFamilyScrollHint();
    initializeFamilySizeFilter();
    initializeGallerySync();
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhanceAll();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
